import { render, staticRenderFns } from "./GrowthValueUse.vue?vue&type=template&id=37e31e6a&scoped=true&"
import script from "./GrowthValueUse.vue?vue&type=script&lang=js&"
export * from "./GrowthValueUse.vue?vue&type=script&lang=js&"
import style0 from "./GrowthValueUse.vue?vue&type=style&index=0&id=37e31e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e31e6a",
  null
  
)

export default component.exports